<!--
 * @description: 居中标题
 * @Author: Jay
 * @Date: 2021-09-24 15:03:33
 * @LastEditors: Jay
 * @LastEditTime: 2021-09-24 15:06:30
-->
<template>
  <div>
    <!-- 标题 -->
    <div v-class="'animate__animated animate__fadeInUp'">
      <div class="text-align padding">
        <p class="font_size_xl text-black">{{ title }}</p>
        <div class="flex align-center justify-center margin-top-xs">
          <p class="twoTitle margin-right-sm"></p>
          <p class="font_size_lg text-gray">{{ engTitle }}</p>
          <p class="twoTitle margin-left-sm"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  nme: "centerTitle",
  props: {
    title: {
      type: String,
      required: true,
    },
    engTitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
//二级标题 左右横线
.twoTitle {
  width: 128px;
  height: 1px;
  background-color: #cccccc;
}
</style>
